import { ResetZoomIcon, ZoomInIcon, ZoomOutIcon } from "constants/Icons";
import { useAppDispatch } from "hooks/StoreHooks";
import { setGridZoom } from "store/Slices/gridLayoutSlice";

import "./Zoom.scss";
const DEFAULT_ZOOM = 100;
const MIN_ZOOM = 20;
const MAX_ZOOM = 200;
const ZOOM_MODIFICATOR = 20;
let currentZoom = DEFAULT_ZOOM;

export default function Zoom() {
  const dispatch = useAppDispatch();

  function handleZoomIn() {
    if (currentZoom < MAX_ZOOM) {
      currentZoom += ZOOM_MODIFICATOR;
      dispatch(setGridZoom(currentZoom));
    }
  }

  function handleZoomOut() {
    if (currentZoom > MIN_ZOOM) {
      currentZoom -= ZOOM_MODIFICATOR;
      dispatch(setGridZoom(currentZoom));
    }
  }

  function handleZoomReset() {
    currentZoom = DEFAULT_ZOOM;
    dispatch(setGridZoom(currentZoom));
  }

  return (
    <div className="zoom-section">
      <ResetZoomIcon onClick={handleZoomReset} />
      <ZoomInIcon onClick={handleZoomIn} />
      <ZoomOutIcon onClick={handleZoomOut} />
    </div>
  );
}
